<template>
  <v-container id="contact-grid" class="mx-auto">
    <div
      v-show="show_alert"
      class="alert alert-success alert-dismissible fade show mt-5"
      role="alert"
    >
      <h5 id="alert-title">
        {{ $t('welcome_word') }}
        <strong>{{ user.prenom + ' ' + user.nom }}</strong>
      </h5>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <v-dialog fullscreen v-model="waiting_dialog">
      <div class="text-center">
        <v-overlay :value="overlay">
          <v-progress-circular
            :width="3"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-overlay>
      </div>
    </v-dialog>
    <v-container
      v-show="new_demand == true"
      row
      justify-center
      align-center
      class="mx-auto mt-1"
    >
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-snackbar
          v-model="editSnackbar"
          :color="editSnackbarColor"
          :timeout="10000"
          :top="true"
          style="z-index: 20000;"
        >
          {{ snackbar_text }}
        </v-snackbar>
        <h4 class="ask-title blue-grey--text darken-1 text-center m-2">
          {{ $t('ask_title') }}
        </h4>
        <div>
          <v-stepper elevation="1" v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">
                {{ $t('personal_info') }}
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2">
                {{ $t('addinfo') }}
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 3" step="3">
                {{ $t('travel_info') }}
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="4" :complete="step > 4">
                {{ $t('stay_info') }}
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="5" :complete="isOkay">
                {{ $t('paiement') }}
              </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items class="mt-10">
              <v-stepper-content ref="step1" step="1">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="lastname"
                      required
                      filled
                      @blur="$v.lastname.$touch()"
                      name="lastname"
                      :label="$t('lastName')"
                      :error-messages="lastnameErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="firstname"
                      required
                      filled
                      @blur="$v.firstname.$touch()"
                      name="fristname"
                      :label="$t('firstName')"
                      :error-messages="firstnameErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-autocomplete
                      v-model="gender"
                      required
                      filled
                      item-text="name"
                      @blur="$v.gender.$touch()"
                      :items="genders"
                      :label="$t('gender')"
                      :error-messages="genderErrors"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div>
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            filled
                            required
                            readonly
                            v-model="birthdate"
                            @blur="$v.birthdate.$touch()"
                            :label="$t('birthday')"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="birthdateErrors"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :locale="langLocal"
                          v-model="birthdate"
                          :active-picker.sync="activePicker"
                          :max="birthday_min_date"
                          @change="save"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="5">
                    <v-autocomplete
                      required
                      v-model="birthcountry"
                      @blur="$v.birthcountry.$touch()"
                      filled
                      :items="birthCountries"
                      :label="$t('birthcountry')"
                      :error-messages="birthcountryErrors"
                      item-text="nom_fr_fr"
                      item-value="nom_fr_fr"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="birthplace"
                      required
                      filled
                      @blur="$v.birthplace.$touch()"
                      name="birthplace"
                      :label="$t('birthplace')"
                      :error-messages="birthplaceErrors"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="nationalityNow"
                      required
                      item-text="nationalite_fr_fr"
                      item-value="nationalite_fr_fr"
                      @blur="$v.nationalityNow.$touch()"
                      :items="nationalities"
                      filled
                      :label="$t('current_nationality')"
                      :error-messages="nationalityNowErrors"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="nationalityOrigin"
                      required
                      item-text="nationalite_fr_fr"
                      item-value="nationalite_fr_fr"
                      @blur="$v.nationalityOrigin.$touch()"
                      :items="nationalities"
                      filled
                      :label="$t('origine_nationality')"
                      :error-messages="nationalityOriginErrors"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="familienstand"
                      required
                      item-text="text"
                      item-value="name"
                      @blur="$v.familienstand.$touch()"
                      :items="familienStandList"
                      filled
                      :label="$t('marital_status')"
                      :error-messages="familienstandErrors"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-btn
                      small
                      :disabled="isLoading"
                      @click="
                        new_demand = false
                        isLoading = false
                      "
                      class="mx-1 m-2"
                      color="error"
                    >
                      {{ $t('close_btn') }}

                      <v-icon right dark>mdi-close-circle</v-icon>
                    </v-btn>

                    <v-btn
                      :loading="isLoading"
                      small
                      color="primary"
                      @click="submitStep1"
                      :disabled="stepTwo || isLoading"
                    >
                      {{ $t('next_btn') }}
                      <v-icon right dark>mdi-arrow-right-bold-circle</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <v-stepper-content ref="step2" step="2">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="adresse"
                      required
                      filled
                      @blur="$v.adresse.$touch()"
                      name="adresse"
                      :label="$t('adresse')"
                      :error-messages="adresseErrors"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="codepostal"
                      required
                      filled
                      @blur="$v.codepostal.$touch()"
                      name="codepostal"
                      :label="$t('postal_code')"
                      :error-messages="codepostalErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="town"
                      required
                      filled
                      @blur="$v.town.$touch()"
                      name="town"
                      :label="$t('town')"
                      :error-messages="townErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vue-phone-number-input
                      @update="getUpdate"
                      class="mt-4 mb-4"
                      ref="phoneinput"
                      :default-country-code="country_code"
                      required
                      :dark="isdark"
                      @blur="$v.phonenumber.$touch()"
                      v-model="phonenumber"
                      :error-messages="phonenumberErrors"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="work"
                      required
                      filled
                      @blur="$v.work.$touch()"
                      name="work"
                      :label="$t('work')"
                      :error-messages="workErrors"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-btn
                  small
                  :disabled="isLoading"
                  @click="
                    new_demand = false
                    isLoading = false
                  "
                  class="mx-1 m-2"
                  color="error"
                >
                  {{ $t('close_btn') }}
                  <v-icon right dark>mdi-close-circle</v-icon>
                </v-btn>
                <v-btn
                  small
                  :disabled="isLoading"
                  @click="
                    step = 1
                    isLoading = false
                    goto('step1')
                  "
                  color="warning"
                  class="mx-1"
                >
                  <v-icon left dark>mdi-arrow-left-bold-circle</v-icon>
                  {{ $t('return_btn') }}
                </v-btn>
                <v-btn
                  :loading="isLoading"
                  small
                  color="primary"
                  class="mx-1"
                  :disabled="stepThree || isLoading"
                  @click="submitStep2"
                >
                  {{ $t('next_btn') }}
                  <v-icon right dark>mdi-arrow-right-bold-circle</v-icon>
                </v-btn>
              </v-stepper-content>

              <v-stepper-content ref="step3" step="3">
                <v-row cols="12" sm="12">
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="passportnumber"
                      @keyup="uppercase"
                      required
                      filled
                      @blur="
                        $v.passportnumber.$touch(), getNationalityonPassport()
                      "
                      :error-messages="passportnumberErrors"
                      type="text"
                      :label="$t('passport_number')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      required
                      v-model="delivercountry"
                      @blur="$v.delivercountry.$touch()"
                      filled
                      :items="birthCountries"
                      :status_demandeitems="birthCountries"
                      :label="$t('delivercountry')"
                      :error-messages="delivercountryErrors"
                      item-text="nom_fr_fr"
                      item-value="nom_fr_fr"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <div>
                      <v-menu
                        ref="delivermenu"
                        v-model="delivermenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            filled
                            readonly
                            required
                            v-model="deliverdate"
                            @blur="$v.deliverdate.$touch()"
                            :label="$t('deliverdate')"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="deliverdateErrors"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="new Date().toISOString().slice(0, 10)"
                          :locale="langLocal"
                          v-model="deliverdate"
                          :active-picker.sync="activeDeliverPicker"
                          @change="deliversave"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="editExpi"
                      v-model="editExpi"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          readonly
                          required
                          filled
                          v-model="expiredate"
                          @blur="$v.expiredate.$touch()"
                          :label="$t('expiredate')"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="expiredateErrors"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :min="passport_min_date"
                        :locale="langLocal"
                        v-model="expiredate"
                        :active-picker.sync="editActiveExpirePicker"
                        @change="expi_save"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      required
                      v-model="acreditationcounrty"
                      @blur="$v.acreditationcounrty.$touch()"
                      filled
                      :items="countries"
                      :label="$t('acreditationcounrty')"
                      :error-messages="acreditationcounrtyErrors"
                      item-text="pays_origine"
                      item-value="id"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      required
                      v-model="motifvoyage"
                      @blur="$v.motifvoyage.$touch()"
                      filled
                      :items="typesvisa"
                      label="Motif du voyage"
                      :error-messages="motifErrors"
                      item-text="visa_designation"
                      item-value="id"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div>
                      <v-menu
                        ref="startmenu"
                        v-model="startmenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            filled
                            readonly
                            required
                            v-model="startdate"
                            @blur="$v.startdate.$touch()"
                            :label="$t('startdate')"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="startdateErrors"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :locale="langLocal"
                          v-model="startdate"
                          :min="new Date().toISOString().slice(0, 10)"
                          :max="subtractMonths(new Date(), +60)"
                          :active-picker.sync="activeStartPicker"
                          @change="startsave"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="endmenu"
                      v-model="endmenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          readonly
                          required
                          filled
                          v-model="enddate"
                          @blur="$v.enddate.$touch()"
                          :label="$t('enddate')"
                          :min="new Date().toISOString().slice(0, 10)"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="enddateErrors"
                          :disabled="startdate == null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :min="startdate"
                        :locale="langLocal"
                        v-model="enddate"
                        :active-picker.sync="activeEndPicker"
                        @change="endsave"
                        :max="subtractMonths(new Date(), +60)"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="10" sm="10">
                    <v-file-input
                      @change="copypassportChange"
                      show-size
                      required
                      @blur="$v.copypassport.$touch()"
                      v-model="copypassport"
                      :label="$t('copypassport')"
                      filled
                      prepend-icon="mdi-camera"
                      :error-messages="copypassportErrors"
                      accept="image/png, image/jpeg, image/bmp,  image/svg"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="2" sm="2">
                    <div v-if="copypassport">
                      <img
                        class="img-viewer"
                    
                        style="
                          margin: 5px;
                          max-width: 50px;
                          max-height: 50px;
                          border-radius: 3px;
                        "
                        v-bind:src="filepasseport_link"
                      />
                      <viewer style="display: none;" :images="current_image">
                        <img :src="filepasseport_link" />
                      </viewer>
                    </div>
                  </v-col>
                  <v-col cols="10" sm="10">
                    <v-file-input
                      @change="justificatiflogementChange"
                      show-size
                      required
                      @blur="$v.justificatiflogement.$touch()"
                      v-model="justificatiflogement"
                      :label="$t('justificatiflogement')"
                      filled
                      prepend-icon="mdi-camera"
                      accept="image/png, image/jpeg, image/bmp,  image/svg"
                      :error-messages="justificatiflogementErrors"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="2" sm="2">
                    <div v-if="justificatiflogement">
                      <img
                        class="img-viewer"

                        style="
                          margin: 5px;
                          max-width: 50px;
                          max-height: 50px;
                          border-radius: 3px;
                        "
                        v-bind:src="filelogement_link"
                      />
                      <viewer style="display: none;" :images="current_image">
                        <img :src="filelogement_link" />
                      </viewer>
                    </div>
                  </v-col>

                  <v-col cols="10" sm="10">
                    <v-file-input
                      @change="flugticketChange"
                      show-size
                      required
                      @blur="$v.flugticket.$touch()"
                      v-model="flugticket"
                      :label="$t('flugticket')"
                      filled
                      prepend-icon="mdi-camera"
                      accept="image/png, image/jpeg, image/bmp,  image/svg"
                      :error-messages="flugticketErrors"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="2" sm="2">
                    <div v-if="flugticket">
                      <img
                        class="img-viewer"
                     
                        style="
                          margin: 5px;
                          max-width: 50px;
                          max-height: 50px;
                          border-radius: 3px;
                        "
                        v-bind:src="flugticket_link"
                      />
                      <viewer style="display: none;" :images="current_image">
                        <img :src="flugticket_link" />
                      </viewer>
                    </div>
                  </v-col>
                </v-row>
                <v-btn
                  small
                  :disabled="isLoading"
                  @click="
                    new_demand = false
                    isLoading = false
                  "
                  class="mx-1 m-2"
                  color="error"
                >
                  {{ $t('close_btn') }}
                  <v-icon right dark>mdi-close-circle</v-icon>
                </v-btn>
                <v-btn
                  small
                  :disabled="isLoading"
                  @click="
                    step = 2
                    goto('step2')
                    isLoading = false
                  "
                  class="mx-1"
                  color="warning"
                >
                  <v-icon left dark>mdi-arrow-left-bold-circle</v-icon>
                  {{ $t('return_btn') }}
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  :loading="isLoading"
                  :disabled="stepFour || isLoading"
                  @click="submitStep3"
                >
                  {{ $t('next_btn') }}
                  <v-icon right dark>mdi-arrow-right-bold-circle</v-icon>
                </v-btn>
              </v-stepper-content>
              <v-stepper-content ref="step4" step="4">
                <v-row>
                  <v-col v-if="has_contact == true" cols="12">
                    <h4>{{ $t('demand_contact_title') }}</h4>
                  </v-col>
                  <v-col v-if="has_contact == true" cols="12" sm="12">
                    <v-text-field
                      v-model="contactname"
                      required
                      filled
                      @blur="$v.contactname.$touch()"
                      name="contactname"
                      :label="$t('contactname')"
                      :error-messages="contactnameErrors"
                    ></v-text-field>
                  </v-col>

                  <v-col v-if="has_contact == true" cols="12" sm="6">
                    <v-text-field
                      v-model="contactadresse"
                      required
                      filled
                      @blur="$v.contactadresse.$touch()"
                      name="contactadresse"
                      :label="$t('contactadresse')"
                      :error-messages="contactadresseErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="has_contact == true" cols="12" sm="6">
                    <v-text-field
                      v-model="contacttown"
                      required
                      filled
                      @blur="$v.contacttown.$touch()"
                      name="contacttown"
                      :label="$t('contacttown')"
                      :error-messages="contacttownErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="has_contact == true" cols="12" sm="6">
                    <vue-phone-number-input
                      @update="contactphoneGetUpdate"
                      ref="contactphone"
                      class="mt-4 mb-4"
                      :default-country-code="country_code_contact"
                      required
                      :dark="isdark"
                      @blur="$v.contactphone.$touch()"
                      v-model="contactphone"
                      :error-messages="contactphoneErrors"
                    />
                  </v-col>
                  <v-col v-if="has_contact == true" cols="12" sm="6">
                    <v-text-field
                      v-model="contactemail"
                      prepend-icon="mdi-email"
                      type="email"
                      required
                      filled
                      @blur="$v.contactemail.$touch()"
                      name="contactemail"
                      :label="$t('contactemail')"
                      :error-messages="contactemailErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    style="margin-top: auto; margin-bottom: auto;"
                    cols="12"
                    sm="6"
                  >
                    <h4>{{ $t('has_familly') }}</h4>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-switch
                      class="ml-2"
                      v-model="switch1"
                      inset
                      :label="has_familly"
                    ></v-switch>
                  </v-col>
                  <v-col v-if="switch1" cols="12" sm="12">
                    <h4>{{ $t('familly_title') }}</h4>
                  </v-col>
                  <v-col v-if="switch1" cols="12" sm="12">
                    <v-text-field
                      v-model="famillyname"
                      required
                      filled
                      @blur="$v.famillyname.$touch()"
                      name="famillyname"
                      :label="$t('famillyname')"
                      :error-messages="famillynameErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="switch1" cols="12" sm="6">
                    <v-text-field
                      v-model="famillyadresse"
                      required
                      filled
                      @blur="$v.famillyadresse.$touch()"
                      name="famillyadresse"
                      :label="$t('famillyadresse')"
                      :error-messages="famillyadresseErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="switch1" cols="12" sm="6">
                    <v-text-field
                      v-model="famillytown"
                      required
                      filled
                      @blur="$v.famillytown.$touch()"
                      name="contacttown"
                      :label="$t('famillytown')"
                      :error-messages="famillytownErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="switch1" cols="12" sm="6">
                    <vue-phone-number-input
                      @update="famillyphoneGetUpdate"
                      ref="famillyphone"
                      class="mt-4 mb-4"
                      :only-countries="['CM']"
                      :default-country-code="country_code_familly"
                      required
                      :dark="isdark"
                      @blur="$v.famillyphone.$touch()"
                      v-model="famillyphone"
                      :error-messages="famillyphoneErrors"
                    />
                  </v-col>
                  <v-col v-if="switch1" cols="12" sm="6">
                    <v-text-field
                      v-model="famillyemail"
                      prepend-icon="mdi-email"
                      type="email"
                      required
                      filled
                      @blur="$v.famillyemail.$touch()"
                      name="famillyemail"
                      :label="$t('famillyemail')"
                      :error-messages="famillyemailErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <h4>{{ $t('cam_residence') }}</h4>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="residencename"
                      required
                      filled
                      @blur="$v.residencename.$touch()"
                      name="residencename"
                      :label="$t('residencename')"
                      :error-messages="residencenameErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="residenceadresse"
                      required
                      filled
                      @blur="$v.residenceadresse.$touch()"
                      name="residenceadresse"
                      :label="$t('residenceadresse')"
                      :error-messages="residenceadresseErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="residencetown"
                      required
                      filled
                      @blur="$v.residencetown.$touch()"
                      name="residencetown"
                      :label="$t('residencetown')"
                      :error-messages="residencetownErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <vue-phone-number-input
                      @update="residencephoneGetUpdate"
                      class="mt-4 mb-4"
                      ref="residencephone"
                      :only-countries="['CM']"
                      :default-country-code="country_code_residence"
                      required
                      :dark="isdark"
                      @blur="$v.residencephone.$touch()"
                      v-model="residencephone"
                      :error-messages="residencephoneErrors"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="residenceemail"
                      prepend-icon="mdi-email"
                      type="email"
                      required
                      filled
                      @blur="$v.residenceemail.$touch()"
                      name="residenceEmail"
                      :label="$t('residenceemail')"
                      :error-messages="residenceemailErrors"
                    ></v-text-field>
                  </v-col>

                  <v-col>
                    <v-checkbox
                      class="m-3"
                      required
                      color="primary"
                      :error-messages="checkboxErrors"
                      @change="$v.checkbox.$touch()"
                      v-model="checkbox"
                    >
                      <template v-slot:label>
                        <p>
                          {{ $t('security_title') }}
                        </p>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-btn
                  small
                  :disabled="isLoading"
                  @click="
                    new_demand = false
                    isLoading = false
                  "
                  class="mx-1 m-2"
                  color="error"
                >
                  {{ $t('close_btn') }}
                  <v-icon right dark>mdi-close-circle</v-icon>
                </v-btn>
                <v-btn
                  small
                  :disabled="isLoading"
                  @click="
                    step = 3
                    isLoading = false
                    goto('step3')
                  "
                  class="mx-1 m-2"
                  color="warning"
                >
                  <v-icon left dark>mdi-arrow-left-bold-circle</v-icon>
                  {{ $t('return_btn') }}
                </v-btn>
                <v-btn
                  small
                  class="mx-1 m-2"
                  color="primary"
                  :disabled="stepFive || isLoading"
                  :loading="isLoading"
                  @click="submitStep4"
                >
                  {{ $t('next_btn') }}
                  <v-icon right dark>mdi-arrow-right-bold-circle</v-icon>
                </v-btn>
              </v-stepper-content>
              <v-stepper-content ref="step5" step="5">
                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('lastName') }} : {{ lastname }}
                </div>

                <v-divider></v-divider>

                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('firstName') }} : {{ firstname }}
                </div>

                <v-divider></v-divider>

                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('passport') }} : {{ passportnumber }}
                </div>

                <v-divider></v-divider>

                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('birthday') }} : {{ formatDate(birthdate) }}
                </div>

                <v-divider></v-divider>

                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('acreditationcounrty') }} :
                  <span v-for="item in countries" :key="item.id">
                    <span v-if="item.id == acreditationcounrty">
                      {{ item.pays_origine }}
                    </span>
                  </span>
                </div>

                <v-divider></v-divider>

                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('startdate') }} : {{ formatDate(startdate) }}
                </div>

                <v-divider></v-divider>

                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('enddate') }} : {{ formatDate(enddate) }}
                </div>

                <v-divider></v-divider>

                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('copypassport') }} :
                  <img
                    class="img-viewer"
                    @click="show_image(filepasseport_link)"
                    style="
                      margin: 5px;
                      max-width: 50px;
                      max-height: 50px;
                      border-radius: 3px;
                    "
                    v-bind:src="filepasseport_link"
                  />
                  <viewer style="display: none;" :images="current_image">
                    <img :src="filepasseport_link" />
                  </viewer>
                </div>

                <v-divider></v-divider>

                <div v-bind:style="[isdark == true ? { color: 'white' } : {}]">
                  {{ $t('justificatiflogement') }} :
                  <img
                    class="img-viewer"
                    @click="show_image(filelogement_link)"
                    style="
                      margin: 5px;
                      max-width: 50px;
                      max-height: 50px;
                      border-radius: 3px;
                    "
                    v-bind:src="filelogement_link"
                  />
                  <viewer style="display: none;" :images="current_image">
                    <img :src="filelogement_link" />
                  </viewer>
                </div>

                <v-divider></v-divider>

                <div
                  class="mb-5"
                  v-bind:style="[isdark == true ? { color: 'white' } : {}]"
                >
                  {{ $t('justificatiflogement') }} :
                  <img
                    class="img-viewer"
                    @click="show_image(flugticket_link)"
                    style="
                      margin: 5px;
                      max-width: 50px;
                      max-height: 50px;
                      border-radius: 3px;
                    "
                    v-bind:src="flugticket_link"
                  />
                  <viewer style="display: none;" :images="current_image">
                    <img :src="flugticket_link" />
                  </viewer>
                </div>

                <v-divider></v-divider>

                <v-btn
                  small
                  :disabled="isLoading"
                  @click="
                    new_demand = false
                    isLoading = false
                  "
                  class="mx-1 m-2"
                  color="error"
                >
                  {{ $t('close_btn') }}
                  <v-icon right dark>mdi-close-circle</v-icon>
                </v-btn>
                <v-btn
                  small
                  :disabled="isLoading"
                  @click="
                    step = 4
                    isLoading = false
                    goto('step4')
                  "
                  class="mx-1"
                  color="warning"
                >
                  <v-icon left dark>mdi-arrow-left-bold-circle</v-icon>
                  {{ $t('return_btn') }}
                </v-btn>
                <v-btn
                  small
                  @click="payer"
                  :loading="isLoading"
                  class="mx-1 m-2"
                  color="primary"
                >
                  {{ $t('pay_btn') }}

                  <v-icon right dark>mdi-credit-card</v-icon>
                </v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </v-flex>
    </v-container>
    <v-btn
      row
      :loading="isLoading"
      :disabled="isLoading"
      v-show="!new_demand"
      align-left
      @click="show_newdemande"
      class="mx-3 mt-5"
      color="warning"
    >
      {{ $t('ask_btn') }}
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <v-container row justify-center align-center class="mx-auto mt-4 pt-2 m-0">
      <h3 class="blue-grey--text darken-1 text-center pb-4 m-3">
        {{ $t('list_demand_title') }}
      </h3>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-radio-group
              v-model="radios"
              class="mx-3 mt-5 pt-2"
              mandatory
              align-left
              row
            >
              <v-row>
                <v-col cols="6" md="2" sm="2">
                  <v-radio
                    name="radios"
                    :label="$t('all')"
                    value="all"
                  ></v-radio>
                </v-col>

                <v-col cols="6" md="2" sm="2">
                  <v-radio
                    name="radios"
                    :label="$t('en_cours')"
                    value="Pending"
                  ></v-radio>
                </v-col>

                <v-col cols="6" md="2" sm="2">
                  <v-radio
                    name="radios"
                    label="Complement"
                    value="Complement"
                  ></v-radio>
                </v-col>

                <v-col cols="6" md="2" sm="2">
                  <v-radio
                    name="radios"
                    :label="$t('approuve')"
                    value="Valider"
                  ></v-radio>
                </v-col>
                <v-col cols="6" md="2" sm="2">
                  <v-radio
                    name="radios"
                    :label="$t('reject')"
                    value="Reject"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="this.getLocaleMessages['search_text']"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="getHeaders"
          :items="demands"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items-per-page="15"
          class="elevation-2"
          :search="search"
        >
          <template v-slot:[`item.status_demande`]="{ item }">
            <v-btn
              small
              :loading="loadingItem === item.code_demande"
              color="primary"
              @click="payer_demande(item.code_demande)"
              v-if="!item.id_transaction"
            >
              {{ $t('pay_btn') }}
            </v-btn>
            <v-chip
              v-if="item.id_transaction"
              :color="getColor(item.status_demande, item.level)"
              class="text-white"
            >
              {{ item.status_demande }}
            </v-chip>
          </template>
          <template v-slot:[`item.full_name`]="{ item }">
            {{ item.nom + ' ' + item.prenom }}
          </template>
          <template v-slot:[`item.code_demande`]="{ item }">
            {{ item.code_demande }}
            <v-btn class="text-center" icon>
              <v-icon
                small
                color="green"
                v-clipboard:copy="item.code_demande"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                mdi-clipboard-multiple
              </v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <!-- <v-icon
              small
              @click="view_demand(item)"
              v-if="
                item.status_demande.toLowerCase() == 'valider' &&
                item.level.toLowerCase() == 'final'
              "
              color="green"
              class="mr-2"
            >
              mdi-passport
            </v-icon> -->

            <v-icon
              small
              v-if="item.status_demande.toLowerCase() != 'complement'"
              class="mr-2"
              @click="editItem('voir', item)"
            >
              mdi-eye
            </v-icon>

            <v-icon
              small
              v-if="
                (item.status_demande.toLowerCase() == 'pending' &&
                  item.level == 'Niveau1') ||
                item.status_demande.toLowerCase() == 'complement'
              "
              class="mr-2"
              @click="editItem('pencil', item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-col>
              <i style="font-size: 30px;" class="fa-solid fa-circle-info"></i>
              <p>{{ $t('no_data') }}</p>
            </v-col>
            <v-col>
              <v-btn text color="primary" @click="getDemands">
                {{ $t('btn_reset') }}
              </v-btn>
            </v-col>
          </template>
        </v-data-table>
      </v-flex>

      <v-dialog v-model="visa_dialog" width="500">
        <v-card id="visa_dialog" v-if="approuve_demand">
          <v-card-title>
            <v-btn
              small
              icon
              color="red"
              class="mr-2"
              @click="visa_dialog = false"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>

            {{ $t('cameroun_republic') }}
          </v-card-title>

          <v-card-text>
            <v-list-item three-line>
              <v-list-item-content>
                <div class="col-md-12">
                  <span class="font-weight-bold">Code</span>
                  : {{ approuve_demand.code_demande }}
                  <br />
                  <span class="font-weight-bold">
                    {{ $t('passport_number') }}
                  </span>
                  : {{ approuve_demand.numpasseport }}
                  <br />
                  <span class="font-weight-bold">
                    {{ $t('lastName') }}
                  </span>
                  : {{ approuve_demand.nom }}
                  <br />
                  <span class="font-weight-bold">
                    {{ $t('firstName') }}
                  </span>
                  :{{ approuve_demand.prenom }}
                  <br />
                  <span class="font-weight-bold">
                    {{ $t('birthday') }}
                  </span>
                  : {{ approuve_demand.birthday }}
                  <br />
                  <span class="font-weight-bold">
                    {{ $t('gender') }}
                  </span>
                  : {{ approuve_demand.genre }}
                  <br />
                  <span class="font-weight-bold">
                    {{ $t('nationality') }}
                  </span>
                  : {{ approuve_demand.origine_nationality }}
                  <br />
                  <span class="font-weight-bold">
                    {{ $t('travel_reason') }}
                  </span>
                  : {{ approuve_demand.id_type_visas }}

                  <br />

                  <v-row>
                    <div class="mt-5 col-md-12">
                      <div class="col-md-12 col-12">
                        <span>{{ $t('delivert_at') }} :</span>
                        {{ approuve_demand.pays_origine }}
                      </div>
                      <div class="col-md-12 col-12">
                        <span>{{ $t('valide_from') }}</span>
                        : {{ approuve_demand.updated_at }}
                      </div>
                      <div class="col-md-12 col-12">
                        <span>{{ $t('valide_to') }}</span>
                        : {{ approuve_demand.validite }}
                      </div>
                    </div>
                  </v-row>
                </div>
              </v-list-item-content>

              <v-list-item-avatar tile size="80" color="grey">
                <qr-code
                  :text="approuve_demand.code_demande"
                  :size="78"
                ></qr-code>
              </v-list-item-avatar>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        content-class="custimize-dialog"
        scrollable
        v-model="dialog"
        style="z-index: 2000;"
        :retain-focus="false"
      >
        <v-card>
          <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            :timeout="10000"
            :top="true"
          >
            {{ snackbar_text }}
          </v-snackbar>
          <v-card-title class="text-h5 grey lighten-2">
            <v-btn icon x-large color="red" text @click="closeEdit">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <details-demand
              v-bind:demand.sync="show_demand"
              :action="select_action"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<script>
import { getIndicatif, getIndicatifNum } from '../phoneCodeCountries.js'
import DetailsDemand from '../components/DetailsDemand.vue'
import 'viewerjs/dist/viewer.css'
import moment from 'moment'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import {
  required,
  minLength,
  helpers,
  maxLength,
  email,
  sameAs,
} from 'vuelidate/lib/validators'
import { i18n } from '../plugins/i18n'
const alphaNumAndDotValidator = helpers.regex('alphaNumAndDot', /^[a-z\d.]*$/i)
const regEx = new RegExp(/^.*\.(jpg|JPG|jpeg|JPEG|png|PNG|svg|SVG)$/i)
const nameRegex = helpers.regex(
  'alphaNum',
  /^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/,
)
import VueQRCodeComponent from 'vue-qrcode-component'

const file_size_validation = (value, vm) => {
  if (!value) {
    return false
  }
  let file = value
  return file.size < 2000000
}

export default {
  name: 'Demand',
  components: {
    'vue-phone-number-input': VuePhoneNumberInput,
    'qr-code': VueQRCodeComponent,
    'details-demand': DetailsDemand,
  },
  mixins: [validationMixin],
  data() {
    return {
      phoneFormatted: null,
      contactPhoneFormatted: null,
      famillyPhoneFormatted: null,
      residencePhoneFormatted: null,
      overlay: true,
      waiting_dialog: true,
      current_image: null,
      filepasseport_link: '',
      filelogement_link: '',
      flugticket_link: '',
      country_code: 'CM',
      country_code_contact: 'CM',
      country_code_familly: 'CM',
      country_code_residence: 'CM',
      codeDemande: null,
      idDemande: null,
      show_demand: null,
      select_action: null,
      checkbox: false,
      contactname: '',
      contactadresse: '',
      contacttown: '',
      contactphone: null,
      contactemail: '',
      famillyname: '',
      famillyadresse: '',
      famillytown: '',
      famillyphone: null,
      famillyemail: '',
      residencename: null,
      residenceadresse: null,
      residencetown: null,
      residencephone: null,
      residenceemail: null,
      has_contact: false,
      switch1: false,
      has_familly: null,
      startmenu: null,
      startdate: null,
      enddate: null,
      endmenu: null,
      flugticket: null,
      deliverdate: null,
      adresse: null,
      codepostal: null,
      town: null,
      work: null,

      familienStandList: [
        {
          id: 0,
          name: 'Marié',
          text: 'to_marry',
        },
        {
          id: 1,
          name: 'Veuve',
          text: 'Veuve',
        },
        {
          id: 1,
          name: 'Célibataire',
          text: 'celibataire',
        },

        {
          id: 1,
          name: 'Célibataire san enfant',
          text: 'celi_nokid',
        },
        {
          id: 1,
          name: 'Célibataire avec enfant',
          text: 'celi_withkid',
        },
      ],
      acreditationcounrty: null,
      delivercountry: null,
      birthplace: null,
      familienstand: null,
      nationalityNow: null,
      nationalityOrigin: null,
      passport_images: null,
      logement_images: null,
      mission_images: null,
      complement_images: null,
      status_demande: null,
      message: null,
      complement_file: null,
      complement: null,
      show_mission: false,
      approuve_demand: null,
      visa_dialog: false,
      birthday_min_date: null,
      passport_min_date: null,
      code_selected: null,
      snackbarColor: 'default',
      snackbar: false,
      editSnackbar: false,
      editSnackbarColor: 'default',
      show_alert: true,
      snackbar_text: '',
      search_block: false,
      alldemands: '',
      radios: '',
      sortBy: 'created_at',
      sortDesc: true,
      visa: null,
      isLoading: false,
      connecteduser: '',
      phonenumber: '',
      returndata: '',
      passportnumber: '',
      visatype: '',
      firstname: '',
      comment: null,
      lastname: '',
      new_demand: false,
      search: '',
      gender: '',
      motifvoyage: '',
      ordremission: null,
      ordremission_name: null,
      copypassport: null,
      complementfile: null,
      complementfile_name: null,
      copypassportfilename: null,
      justificatiflogement: null,
      justificatiflogementfilename: null,
      activePicker: null,
      editActivePicker: null,
      activeExpirePicker: null,
      editActiveExpirePicker: null,
      activeDeliverPicker: null,
      activeStartPicker: null,
      activeEndPicker: null,
      menu: false,
      editMenu: false,
      delivermenu: false,
      expi: false,
      editExpi: false,
      isOkay: false,
      birthdate: '',
      expiredate: '',
      birthcountry: null,
      step: 1,
      dialog: false,
      //make select
      genders: [
        {
          name: 'F',
          value: 'F',
        },
        {
          name: 'M',
          value: 'M',
        },
      ],
      demands: [],
      headers: [],
      loadingItem: null,
    }
  },
  validations: {
    checkbox: { required, sameAs: sameAs(() => true) },
    acreditationcounrty: { required },
    contactname: { required },
    contactadresse: { required },
    contacttown: { required },
    contactphone: { required },
    contactemail: { required, email },
    famillyname: { required },
    famillyadresse: { required },
    famillytown: { required },
    famillyphone: { required },
    famillyemail: { required, email },
    residencename: { required },
    residenceadresse: { required },
    residencetown: { required },
    residencephone: { required },
    residenceemail: { required, email },
    startdate: { required },
    enddate: { required },
    adresse: { required },
    codepostal: { required },
    town: { required },
    work: { required },
    firstname: { required, nameRegex },
    lastname: { required, nameRegex },
    gender: { required },
    birthdate: { required },
    visatype: { required },
    birthcountry: { required },
    delivercountry: { required },
    deliverdate: { required },
    birthplace: { required },
    motifvoyage: { required },
    familienstand: { required },
    nationalityOrigin: { required },
    nationalityNow: { required },
    expiredate: { required },
    phonenumber: { required },
    flugticket: { required, file_size_validation },
    copypassport: { required, file_size_validation },
    justificatiflogement: { required, file_size_validation },
    passportnumber: {
      required,
      alphaNumAndDotValidator,
      minLength: minLength(5),
      maxLength: maxLength(9),
    },
  },
  beforeCreate() {
    this.isLoading = false
  },
  created() {
    this.getTraduction()
    this.$store.dispatch('setCurrentRoute', this.$route.name)

    this.has_familly = this.getLocaleMessages['no']
    // this.has_familly = this.getLocaleMessages[this.has_familly];

    this.birthday_min_date = this.yearDiff(14)
    this.passport_min_date = this.subtractMonths(new Date(), +6)

    // this.expiredate = "2022-06-04";
    this.$root.$i18n.locale = this.langLocal
    this.connecteduser = this.$store.state.user
    this.lastname = this.$store.state.user.nom
    this.firstname = this.$store.state.user.prenom

    this.$store.dispatch('getcountries')
    this.$store.dispatch('getnationalities')
    this.$store.dispatch('gettypesvisa')
    this.$store.dispatch('getBirthCountries')
    this.getDemands()
    moment.locale(this.langLocal)
  },
  computed: {
    can_submit() {
      if (
        this.$v.firstname.$invalid ||
        this.$v.lastname.$invalid ||
        this.$v.gender.$invalid ||
        this.$v.birthdate.$invalid ||
        this.$v.visatype.$invalid ||
        this.$v.birthcountry.$invalid ||
        this.$v.birthplace.$invalid ||
        this.$v.motifvoyage.$invalid ||
        this.$v.nationalityOrigin.$invalid ||
        this.$v.nationalityNow.$invalid ||
        this.$v.expiredate.$invalid ||
        this.$v.phonenumber.$invalid ||
        this.$v.copypassport.$invalid ||
        this.$v.justificatiflogement.$invalid ||
        this.$v.passportnumber.$invalid ||
        this.$v.familienstand.$invalid ||
        this.$v.deliverdate.$invalid ||
        this.$v.startdate.$invalid ||
        this.$v.enddate.$invalid ||
        this.$v.contactname.$invalid ||
        this.$v.contactadresse.$invalid ||
        this.$v.contacttown.$invalid ||
        this.$v.contactphone.$invalid ||
        this.$v.contactemail.$invalid ||
        this.$v.famillyname.$invalid ||
        this.$v.famillyadresse.$invalid ||
        this.$v.famillytown.$invalid ||
        this.$v.famillyphone.$invalid ||
        this.$v.famillyemail.$invalid ||
        this.$v.residencename.$invalid ||
        this.$v.residenceadresse.$invalid ||
        this.$v.residencetown.$invalid ||
        this.$v.residencephone.$invalid ||
        this.$v.residenceemail.$invalid ||
        this.$v.startdate.$invalid ||
        this.$v.flugticket.$invalid ||
        this.$v.adresse.$invalid ||
        this.$v.codepostal.$invalid ||
        this.$v.town.$invalid ||
        this.$v.work.$invalid ||
        this.$v.acreditationcounrty
      ) {
        return true
      } else {
        return false
      }
    },
    stepTwo() {
      if (
        this.$v.firstname.$invalid ||
        this.$v.lastname.$invalid ||
        this.$v.gender.$invalid ||
        this.$v.birthdate.$invalid ||
        this.$v.birthcountry.$invalid ||
        this.$v.birthplace.$invalid ||
        this.$v.nationalityOrigin.$invalid ||
        this.$v.nationalityNow.$invalid ||
        this.$v.familienstand.$invalid
      ) {
        return true
      } else {
        return false
      }
    },
    stepThree() {
      if (
        this.$v.phonenumber.$invalid ||
        this.$v.adresse.$invalid ||
        this.$v.codepostal.$invalid ||
        this.$v.town.$invalid ||
        this.$v.work.$invalid
      ) {
        return true
      } else {
        return false
      }
    },
    stepFour() {
      if (
        this.$v.expiredate.$invalid ||
        this.$v.delivercountry.$invalid ||
        this.$v.deliverdate.$invalid ||
        this.$v.passportnumber.$invalid ||
        this.$v.copypassport.$invalid ||
        this.$v.justificatiflogement.$invalid ||
        this.$v.flugticket.$invalid ||
        this.$v.motifvoyage.$invalid ||
        this.$v.startdate.$invalid ||
        this.$v.enddate.$invalid ||
        this.$v.acreditationcounrty.$invalid
      ) {
        return true
      } else {
        return false
      }
    },
    stepFive() {
      let firsthand
      if (this.switch1) {
        if (
          this.$v.famillyname.$invalid ||
          this.$v.famillyadresse.$invalid ||
          this.$v.famillytown.$invalid ||
          this.$v.famillyphone.$invalid ||
          this.$v.famillyemail.$invalid
        ) {
          firsthand = true
        } else {
          firsthand = false
        }
      } else {
        firsthand = false
      }

      let secondhand
      if (this.has_contact) {
        if (
          this.$v.contactname.$invalid ||
          this.$v.contactadresse.$invalid ||
          this.$v.contacttown.$invalid ||
          this.$v.contactphone.$invalid ||
          this.$v.contactemail.$invalid
        ) {
          secondhand = true
        } else {
          secondhand = false
        }
      } else {
        secondhand = false
      }

      if (
        firsthand ||
        secondhand ||
        this.$v.residencename.$invalid ||
        this.$v.residenceadresse.$invalid ||
        this.$v.residencetown.$invalid ||
        this.$v.residencephone.$invalid ||
        this.$v.residenceemail.$invalid ||
        this.$v.checkbox.$invalid
      ) {
        return true
      } else {
        return false
      }
    },
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.langLocal]
    },
    getHeaders() {
      this.headers = [
        {
          text: 'N°',
          align: 'center',
          value: 'code_demande',
        },
        {
          text:
            this.getLocaleMessages['lastName'] +
            ' & ' +
            this.getLocaleMessages['firstName'],
          align: 'center',
          value: 'full_name',
        },

        {
          text: this.getLocaleMessages['country'],
          align: 'center',
          value: 'pays_origine',
        },
        {
          text: this.getLocaleMessages['visa_type'],
          align: 'center',
          value: 'type_visas',
        },
        {
          text: this.getLocaleMessages['statut'],
          align: 'center',
          value: 'status_demande',
        },
        { text: 'Date', align: 'center', value: 'updated_at' },
        {
          text: 'Action',
          align: 'center',
          value: 'action',
        },
      ]
      return this.headers
    },

    phonenumberErrors() {
      const errors = []
      if (!this.$v.phonenumber.$dirty) return errors
      !this.$v.phonenumber.required &&
        errors.push(this.getLocaleMessages['required_phonenumber'])
      return errors
    },
    firstnameErrors() {
      const errors = []
      if (!this.$v.firstname.$dirty) return errors
      !this.$v.firstname.required &&
        errors.push(this.getLocaleMessages['required_firstname'])
      !this.$v.firstname.nameRegex &&
        errors.push(this.getLocaleMessages['caracter_firstname'])
      return errors
    },
    familienstandErrors() {
      const errors = []
      if (!this.$v.familienstand.$dirty) return errors
      !this.$v.familienstand.required &&
        errors.push(this.getLocaleMessages['required_marital_status'])

      return errors
    },

    lastnameErrors() {
      const errors = []
      if (!this.$v.lastname.$dirty) return errors
      !this.$v.lastname.required &&
        errors.push(this.getLocaleMessages['required_lastname'])
      !this.$v.lastname.nameRegex &&
        errors.push(this.getLocaleMessages['caracter_lastname'])
      return errors
    },
    genderErrors() {
      const errors = []
      if (!this.$v.gender.$dirty) return errors
      !this.$v.gender.required &&
        errors.push(this.getLocaleMessages['required_gender'])
      return errors
    },
    birthdateErrors() {
      const errors = []
      if (!this.$v.birthdate.$dirty) return errors
      !this.$v.birthdate.required &&
        errors.push(this.getLocaleMessages['required_birthdate'])
      return errors
    },

    deliverdateErrors() {
      const errors = []
      if (!this.$v.deliverdate.$dirty) return errors
      !this.$v.deliverdate.required &&
        errors.push(this.getLocaleMessages['required_deliverdate'])
      return errors
    },
    Errors() {
      const errors = []
      if (!this.$v.birthdate.$dirty) return errors
      !this.$v.birthdate.required &&
        errors.push(this.getLocaleMessages['required_birthdate'])
      return errors
    },
    birthplaceErrors() {
      const errors = []
      if (!this.$v.birthplace.$dirty) return errors
      !this.$v.birthplace.required &&
        errors.push(this.getLocaleMessages['required_birthplace'])
      return errors
    },

    birthcountryErrors() {
      const errors = []
      if (!this.$v.birthcountry.$dirty) return errors
      !this.$v.birthcountry.required &&
        errors.push(this.getLocaleMessages['required_birthcountry'])
      return errors
    },
    visaTypeErrors() {
      const errors = []
      if (!this.$v.visatype.$dirty) return errors
      !this.$v.visatype.required &&
        errors.push(this.getLocaleMessages['required_visatype'])
      return errors
    },
    motifErrors() {
      const errors = []
      if (!this.$v.motifvoyage.$dirty) return errors
      !this.$v.motifvoyage.required &&
        errors.push(this.getLocaleMessages['required_motif'])
      return errors
    },
    nationalityNowErrors() {
      const errors = []
      if (!this.$v.nationalityNow.$dirty) return errors
      !this.$v.nationalityNow.required &&
        errors.push(this.getLocaleMessages['required_current_nationality'])
      return errors
    },
    nationalityOriginErrors() {
      const errors = []
      if (!this.$v.nationalityOrigin.$dirty) return errors
      !this.$v.nationalityOrigin.required &&
        errors.push(this.getLocaleMessages['required_origine_nationality'])
      return errors
    },
    expiredateErrors() {
      const errors = []
      if (!this.$v.expiredate.$dirty) return errors
      !this.$v.expiredate.required &&
        errors.push(this.getLocaleMessages['required_expiredate'])
      return errors
    },
    delivercountryErrors() {
      const errors = []
      if (!this.$v.delivercountry.$dirty) return errors
      !this.$v.delivercountry.required &&
        errors.push(this.getLocaleMessages['required_delivercountry'])
      return errors
    },

    passportnumberErrors() {
      const errors = []
      if (!this.$v.passportnumber.$dirty) return errors
      !this.$v.passportnumber.required &&
        errors.push(this.getLocaleMessages['required_passportnumber'])
      !this.$v.passportnumber.alphaNumAndDotValidator &&
        errors.push(this.getLocaleMessages['caracter_passportnumber'])
      !this.$v.passportnumber.minLength &&
        errors.push(this.getLocaleMessages['min_passportnumber'])
      !this.$v.passportnumber.maxLength &&
        errors.push(this.getLocaleMessages['max_passportnumber'])
      return errors
    },
    copypassportErrors() {
      const errors = []
      if (!this.$v.copypassport.$dirty) return errors
      !this.$v.copypassport.required &&
        errors.push(this.getLocaleMessages['required_copypassport'])
      !this.$v.copypassport.file_size_validation && errors.push('file_too_big')
      return errors
    },
    justificatiflogementErrors() {
      const errors = []
      if (!this.$v.justificatiflogement.$dirty) return errors
      !this.$v.justificatiflogement.required &&
        errors.push(this.getLocaleMessages['required_justificatiflogement'])
      !this.$v.justificatiflogement.file_size_validation &&
        errors.push(this.getLocaleMessages['file_too_big'])
      return errors
    },
    flugticketErrors() {
      const errors = []
      if (!this.$v.flugticket.$dirty) return errors
      !this.$v.flugticket.required &&
        errors.push(this.getLocaleMessages['required_flugticket'])
      !this.$v.flugticket.file_size_validation && errors.push('file_too_big')
      return errors
    },
    startdateErrors() {
      const errors = []
      if (!this.$v.startdate.$dirty) return errors
      !this.$v.startdate.required &&
        errors.push(this.getLocaleMessages['required_startdate'])
      return errors
    },
    enddateErrors() {
      const errors = []
      if (!this.$v.enddate.$dirty) return errors
      !this.$v.enddate.required &&
        errors.push(this.getLocaleMessages['required_enddate'])
      return errors
    },
    motifvoyageErrors() {
      const errors = []
      if (!this.$v.motifvoyage.$dirty) return errors
      !this.$v.motifvoyage.required &&
        errors.push(this.getLocaleMessages['required_motifvoyage'])
      return errors
    },
    adresseErrors() {
      const errors = []
      if (!this.$v.adresse.$dirty) return errors
      !this.$v.adresse.required &&
        errors.push(this.getLocaleMessages['required_adresse'])
      return errors
    },
    codepostalErrors() {
      const errors = []
      if (!this.$v.codepostal.$dirty) return errors
      !this.$v.codepostal.required &&
        errors.push(this.getLocaleMessages['required_codepostal'])
      return errors
    },
    townErrors() {
      const errors = []
      if (!this.$v.town.$dirty) return errors
      !this.$v.town.required &&
        errors.push(this.getLocaleMessages['required_town'])
      return errors
    },
    workErrors() {
      const errors = []
      if (!this.$v.work.$dirty) return errors
      !this.$v.work.required &&
        errors.push(this.getLocaleMessages['required_work'])
      return errors
    },

    contactnameErrors() {
      const errors = []
      if (!this.$v.contactname.$dirty) return errors
      !this.$v.contactname.required &&
        errors.push(this.getLocaleMessages['required_work'])
      return errors
    },
    contactadresseErrors() {
      const errors = []
      if (!this.$v.contactadresse.$dirty) return errors
      !this.$v.contactadresse.required &&
        errors.push(this.getLocaleMessages['required_contactadresse'])
      return errors
    },
    contacttownErrors() {
      const errors = []
      if (!this.$v.contacttown.$dirty) return errors
      !this.$v.contacttown.required &&
        errors.push(this.getLocaleMessages['required_contacttown'])
      return errors
    },
    contactphoneErrors() {
      const errors = []
      if (!this.$v.work.$dirty) return errors
      !this.$v.work.required &&
        errors.push(this.getLocaleMessages['required_contactphone'])
      return errors
    },
    contactemailErrors() {
      const errors = []
      if (!this.$v.contactemail.$dirty) return errors
      !this.$v.contactemail.email &&
        errors.push(this.getLocaleMessages['valid_email'])

      !this.$v.contactemail.required &&
        errors.push(this.getLocaleMessages['required_contactemail'])
      return errors
    },
    famillynameErrors() {
      const errors = []
      if (!this.$v.famillyname.$dirty) return errors
      !this.$v.famillyname.required &&
        errors.push(this.getLocaleMessages['required_famillyname'])
      return errors
    },
    famillyadresseErrors() {
      const errors = []
      if (!this.$v.famillyadresse.$dirty) return errors
      !this.$v.famillyadresse.required &&
        errors.push(this.getLocaleMessages['required_famillyadresse'])
      return errors
    },
    famillytownErrors() {
      const errors = []
      if (!this.$v.famillytown.$dirty) return errors
      !this.$v.famillytown.required &&
        errors.push(this.getLocaleMessages['required_famillytown'])
      return errors
    },
    famillyphoneErrors() {
      const errors = []
      if (!this.$v.famillyphone.$dirty) return errors
      !this.$v.famillyphone.required &&
        errors.push(this.getLocaleMessages['required_famillyphone'])
      return errors
    },
    famillyemailErrors() {
      const errors = []
      if (!this.$v.famillyemail.$dirty) return errors
      !this.$v.famillyemail.email && errors.push('valid_email')

      !this.$v.famillyemail.required &&
        errors.push(this.getLocaleMessages['required_famillyphone'])
      return errors
    },
    residencenameErrors() {
      const errors = []
      if (!this.$v.residencename.$dirty) return errors
      !this.$v.residencename.required &&
        errors.push(this.getLocaleMessages['required_residencenamae'])
      return errors
    },
    residenceadresseErrors() {
      const errors = []
      if (!this.$v.residenceadresse.$dirty) return errors
      !this.$v.residenceadresse.required &&
        errors.push(this.getLocaleMessages['required_residenceadresse'])
      return errors
    },
    residencetownErrors() {
      const errors = []
      if (!this.$v.residencetown.$dirty) return errors
      !this.$v.residencetown.required &&
        errors.push(this.getLocaleMessages['required_residencetown'])
      return errors
    },
    residencephoneErrors() {
      const errors = []
      if (!this.$v.residencephone.$dirty) return errors
      !this.$v.residencephone.required &&
        errors.push(this.getLocaleMessages['required_residencephone'])
      return errors
    },
    residenceemailErrors() {
      const errors = []
      if (!this.$v.residenceemail.$dirty) return errors
      !this.$v.residenceemail.email &&
        errors.push(this.getLocaleMessages['valid_email'])
      !this.$v.residenceemail.required &&
        errors.push(this.getLocaleMessages['required_residenceemail'])
      return errors
    },
    acreditationcounrtyErrors() {
      const errors = []
      if (!this.$v.acreditationcounrty.$dirty) return errors
      !this.$v.acreditationcounrty.required &&
        errors.push(this.getLocaleMessages['required_acreditationcounrty'])
      return errors
    },
    checkboxErrors() {
      const errors = []
      if (!this.$v.checkbox.$dirty) return errors
      !this.$v.checkbox.required &&
        errors.push(this.getLocaleMessages['required_checkbox'])
      !this.$v.checkbox.sameAs &&
        errors.push(this.getLocaleMessages['required_checkbox'])

      return errors
    },
    getuser() {
      this.connecteduser = this.$store.state.user
    },
    getEngVisaTypes() {
      let listvisa = [
        {
          id: 0,
          designation: this.getLocaleMessages['type1'],
        },
      ]
    },
    ...mapGetters([
      'current_route',
      'birthCountries',
      'countries',
      'nationalities',
      'user',
      'typesvisa',
      'langLocal',
      'isdark',
    ]),
  },
  watch: {
    phonenumber(val) {
      const code = getIndicatifNum(this.country_code)
      this.phoneFormatted = code + ' ' + val
    },
    contactphone(val) {
      const contactCode = getIndicatifNum(this.country_code_contact)
      this.contactPhoneFormatted = contactCode + ' ' + val
    },
    famillyphone(val) {
      const famillyCode = getIndicatifNum(this.country_code_familly)
      this.famillyPhoneFormatted = famillyCode + ' ' + val
    },
    residencephone(val) {
      const residenceCode = getIndicatifNum(this.country_code_residence)
      this.residencePhoneFormatted = residenceCode + ' ' + val
    },

    langLocal(val) {
      moment.locale(val)
      this.getTraduction()
      if (this.switch1 == true) {
        this.has_familly = this.getLocaleMessages['yes']
      } else {
        this.has_familly = this.getLocaleMessages['no']
      }
    },

    startdate(val) {
      if (val) {
        this.enddate = null
      }
    },

    switch1(val) {
      if (val) {
        this.has_familly = this.getLocaleMessages['yes']
      } else {
        this.has_familly = this.getLocaleMessages['no']
        this.famillyname = null
        this.famillyemail = null
        this.famillyphone = null
        this.famillyadresse = null
        this.famillytown = null
      }
    },
    motifvoyage(val) {
      if (val == 1) {
        this.has_contact = true
      } else {
        this.has_contact = false
        this.contactname = null
        this.contactemail = null
        this.contactphone = null
        this.contactadresse = null
        this.contacttown = null
      }
    },
    new_demand(val) {
      if (!val) {
        this.lastname = null
        this.firstname = null
        this.gender = null
        this.birthdate = null
        this.nationality = null
        this.birthcountry = null
        this.visatype = null
        this.motif = null
        this.passportnumber = null
        this.expiredate = null
        this.copypasspor = null
        this.justificatiflogement = null
        this.phonenumber = null
        this.complement = null
        this.complement_file = null
      }
    },
    visatype(val) {
      console.log(val)
      if (val === 5) {
        this.show_mission = true
      } else {
        this.show_mission = false
        this.ordremission = null
      }
    },
    radios(val) {
      console.log(this.alldemands)
      let listdemands = this.alldemands
      let result
      if (listdemands) {
        if (val == 'Pending') {
          result = listdemands.filter(function (element) {
            return (
              element.id_transaction != null &&
              element.status_demande.toLowerCase() == 'pending'
            )
          })
          this.demands = result
        } else if (val == 'Valider') {
          result = listdemands.filter(function (element) {
            return (
              element.status_demande.toLowerCase() == 'valider' &&
              element.id_transaction != null
            )
          })

          this.demands = result
        } else if (val == 'Reject') {
          result = listdemands.filter(function (element) {
            return (
              element.status_demande.toLowerCase() == 'rejeter' &&
              element.id_transaction != null
            )
          })
          this.demands = result
        } else if (val == 'Complement') {
          result = listdemands.filter(function (element) {
            return (
              element.status_demande.toLowerCase() == 'complement' &&
              element.id_transaction != null
            )
          })
          this.demands = result
        } else {
          this.getDemands()
          this.demands = this.alldemands
        }
      }
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    editMenu(val) {
      val && setTimeout(() => (this.editActivePicker = 'YEAR'))
    },
    expi(val) {
      val && setTimeout(() => (this.activeExpirePicker = 'YEAR'))
    },
    editExpi(val) {
      val && setTimeout(() => (this.editActiveExpirePicker = 'YEAR'))
    },
    delivermenu(val) {
      val && setTimeout(() => (this.activeDeliverPicker = 'YEAR'))
    },
    startmenu(val) {
      val && setTimeout(() => (this.activeStartPicker = 'YEAR'))
    },
    endmenu(val) {
      val && setTimeout(() => (this.activeEndPicker = 'YEAR'))
    },
  },
  methods: {
    getUpdate(val) {
      this.phonenumber = val.nationalNumber
      this.country_code = val.countryCode
      const code = getIndicatifNum(this.country_code)
      this.phoneFormatted = code + ' ' + val.nationalNumber
    },
    contactphoneGetUpdate(val) {
      this.contactphone = val.nationalNumber
      this.country_code_contact = val.countryCode
      const contactCode = getIndicatifNum(this.country_code_contact)
      this.contactPhoneFormatted = contactCode + ' ' + val.nationalNumber
    },
    famillyphoneGetUpdate(val) {
      this.famillyphone = val.nationalNumber
      this.country_code_familly = val.countryCode
      const famillyphoneCode = getIndicatifNum(this.country_code_familly)
      this.famillyPhoneFormatted = famillyphoneCode + ' ' + val.nationalNumber
    },

    residencephoneGetUpdate(val) {
      this.residencephone = val.nationalNumber
      this.country_code_residence = val.countryCode
      const residenceCode = getIndicatifNum(this.country_code_residence)
      this.residencePhoneFormatted = residenceCode + ' ' + val.nationalNumber
    },

    copypassportChange(val) {
      if (!val) {
        return
      }
     this.copypassportCreateImage(val)
      
    },
    copypassportCreateImage(file) {
      const reader = new FileReader()

      reader.onload =(e) =>{

        this.filepasseport_link = e.target.result
      }

      reader.readAsDataURL(file)
      console.log(this.filepasseport_link)
    
    },

    justificatiflogementCreateImage(file) {
      const reader = new FileReader()

      reader.onload = (e) => {
        this.filelogement_link = e.target.result
      }

      reader.readAsDataURL(file)
    },
    justificatiflogementChange(val) {
      if (!val) {
        return
      }
      this.justificatiflogementCreateImage(val)
    },

    flugticketCreateImage(file) {
      const reader = new FileReader()

      reader.onload = (e) => {
        this.flugticket_link = e.target.result
      }

      reader.readAsDataURL(file)
    },
    flugticketChange(val) {
      if (!val) {
        return
      }
      this.flugticketCreateImage(val)
    },

    closeEdit() {
      this.dialog = false
    },

    uppercase() {
      this.passportnumber = this.passportnumber.toUpperCase()
    },

    formatDate(str) {
      return moment(str).subtract(0, 'hour').format('L')
    },

    getTraduction() {
      //traduction function list

      let new_list = Object.entries(this.familienStandList).map((arr) => ({
        text: i18n.t(i18n.messages['reverseLocale'][arr[1].name]),
        name: arr[1].name,
        id: arr[1].id,
      }))

      this.familienStandList = new_list
      console.log(this.familienStandList)
    },
    imageFileChanged(event) {
      var files = event.target.files || event.dataTransfer.files
      if (!files.length) {
        return
      }
      this.copypassport = files[0]
      this.$v.copypassport.$touch()
    },
    async show_newdemande() {
      this.isLoading = true

      // step encours
      const formdata = new FormData()
      formdata.append('id_user', this.user.id)
      await this.$store
        .dispatch('newdemandSetpPending', formdata)
        .then((response) => {
          console.log(response)
          this.isLoading = false
          this.new_demand = true
          this.editedItem = null

          if (response.id) {
            this.lastname = response.nom
            this.firstname = response.prenom
            this.gender = response.genre
            this.birthdate = response.birthday
            this.birthcountry = response.birth_country
            this.birthplace = response.birth_place
            this.nationalityNow = response.now_nationality
            this.nationalityOrigin = response.origine_nationality
            this.familienstand = response.civility
            this.adresse = response.adresse_geo
            this.codepostal = response.code_postal
            this.town = this.work = response.profession

            this.acreditationcounrty = response.pays_acreditation_id
            this.motifvoyage = response.id_type_visa
            this.passportnumber = response.numpasseport
            this.expiredate = response.dateexpirationpasseport
            this.delivercountry = response.pays_delivrance
            this.deliverdate = response.date_delivrance_passeport
            this.startdate = response.date_depart
            this.enddate = response.date_retour

            // les images
            if (response.file_photopasseport) {
              const passport_file = new File(
                ['blob'],
                response.file_photopasseport,
                {
                  lastModified: new Date(Date.now())
                    .toISOString()
                    .substr(0, 10),
                  type: 'text/jpg',
                },
              )
              this.filepasseport_link = response.file_photopasseport
              this.copypassport = passport_file
            }

            if (response.file_justificationlogement) {
              const logement_file = new File(
                ['blob'],
                response.file_justificationlogement,
                {
                  lastModified: new Date(Date.now())
                    .toISOString()
                    .substr(0, 10),
                  type: 'text/jpg',
                },
              )

              this.justificatiflogement = logement_file
              this.filelogement_link = response.file_justificationlogement
            }

            if (response.file_ticket_avaion) {
              const flugticket_file = new File(
                ['blob'],
                response.file_ticket_avaion,
                {
                  lastModified: new Date(Date.now())
                    .toISOString()
                    .substr(0, 10),
                  type: 'text/jpg',
                },
              )

              this.flugticket = flugticket_file
              this.flugticket_link = response.file_ticket_avaion
            }

            if (response.nom_contact_cam != null) {
              this.contactname = response.nom_contact_cam
              this.contactadresse = response.adrese_contact_cam
              this.contacttown = response.ville_contact_cam
              this.contactemail = response.email_contact_cam
            }

            if (response.nom_famille_cam != null) {
              this.famillyname = response.nom_famille_cam
              this.famillyadresse = response.adrese_famille_cam
              this.famillytown = response.ville_famille_cam
              this.famillyemail = response.email_famille_cam
              this.switch1 = true
            }

            this.residencename = response.nom_residence_cam
            this.residenceadresse = response.adrese_residence_cam
            this.residencetown = response.ville_residence_cam
            this.residenceemail = response.email_residence_cam

            // telephone personnel
            if (response.telephone != null) {
              this.phoneFormatted = response.telephone
              this.phonenumber = response.telephone.substring(
                response.telephone.indexOf(' ') + 1,
              )

              this.country_code = getIndicatif(
                response.telephone.substring(
                  1,
                  response.telephone.indexOf(' '),
                ),
              )
            }

            //telephone contact

            if (response.telephone_contact_cam != null) {
              this.contactPhoneFormatted = response.telephone_contact_cam
              this.contactphone = response.telephone_contact_cam.substring(
                response.telephone_contact_cam.indexOf(' ') + 1,
              )

              this.country_code_contact = getIndicatif(
                response.telephone_contact_cam.substring(
                  1,
                  response.telephone_contact_cam.indexOf(' '),
                ),
              )
            }

            //telephone famille
            if (response.telephone_famille_cam != null) {
              this.famillyPhoneFormatted = response.telephone_famille_cam
              this.famillyphone = response.telephone_famille_cam.substring(
                response.telephone_famille_cam.indexOf(' ') + 1,
              )

              this.country_code_familly = getIndicatif(
                response.telephone_famille_cam.substring(
                  1,
                  response.telephone_famille_cam.indexOf(' '),
                ),
              )
            }

            //telephone resisdence

            if (response.telephone_residence_cam != null) {
              this.residencePhoneFormatted = response.telephone_residence_cam
              this.residencephone = response.telephone_residence_cam.substring(
                response.telephone_residence_cam.indexOf(' ') + 1,
              )

              this.country_code_residence = getIndicatif(
                response.telephone_residence_cam.substring(
                  1,
                  response.telephone_residence_cam.indexOf(' '),
                ),
              )
            }

            this.idDemande = response.id
            this.codeDemande = response.code_demande
            this.step = response.last_step
            this.goto('step' + response.last_step)
          }
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
        })
    },
    yearDiff(number) {
      var date = new Date(),
        mnth = ('0' + (date.getMonth() + 1)).slice(-2),
        day = ('0' + date.getDate()).slice(-2)
      return [date.getFullYear() - number, mnth, day].join('-')
    },

    convert(str) {
      var date = new Date(str),
        mnth = ('0' + (date.getMonth() + 1)).slice(-2),
        day = ('0' + date.getDate()).slice(-2)
      return [date.getFullYear(), mnth, day].join('-')
    },

    subtractMonths(date, months) {
      date.setMonth(date.getMonth() + months)
      return this.convert(date)
    },

    onCopy: function (e) {},
    onError: function (e) {
      console.log(e)
    },
    async view_demand(item) {
      this.waiting_dialog = true
      this.visa_dialog = true

      const formdata = new FormData()
      formdata.append('code_demande', item.code_demande)

      await this.$store
        .dispatch('getVisaInfo', formdata)
        .then((response) => {
          this.approuve_demand = response
          this.waiting_dialog = false
        })
        .catch((error) => {
          console.log(error)
        })
      console.log(item)
    },

    async getDemands() {
      await this.$store
        .dispatch('getdemand')
        .then((response) => {
          if (response) {
            response.forEach((demand) => {
              demand.updated_at = this.format_date(demand.updated_at)
            })
            this.alldemands = response

            this.radios = 'all'
            this.demands = response
            this.waiting_dialog = false
            this.overlay = false
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    close() {
      this.dialog = false
    },
 
  
    async editItem(action, item) {
      this.waiting_dialog = true
      this.overlay = true

      // this.status_demande = item.status_demande;

      //get all finformation from demandconde
      const data = new FormData()
      data.append('code_demande', item.code_demande)

      await this.$store
        .dispatch('getDemandByCode', data)
        .then((response) => {
          this.isLoading = false
          if (response) {
            this.show_demand = response
            this.select_action = action
          }

          console.log(this.show_demand)
          this.waiting_dialog = false
          this.overlay = false
        })
        .catch((error) => {
          this.isLoading = false
        })
      this.dialog = true
    },
    goto(refName) {
      var element = this.$refs[refName]
      var top = element.offsetTop
      window.scrollTo(0, top)
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY HH:mm:ss')
      }
    },

    async submitStep1() {
      this.isLoading = true
      // step1

      const formdata = new FormData()
      formdata.append('nom', this.lastname)
      formdata.append('prenom', this.firstname)
      formdata.append('genre', this.gender)
      formdata.append('birthday', this.birthdate)
      formdata.append('birth_country', this.birthcountry)
      formdata.append('birth_place', this.birthplace)
      formdata.append('now_nationality', this.nationalityNow)
      formdata.append('origine_nationality', this.nationalityOrigin)
      formdata.append('civility', this.familienstand)
      formdata.append('code', this.codeDemande)

      await this.$store
        .dispatch('newdemandSetp1', formdata)
        .then((response) => {
          console.log(response)
          this.isLoading = false
          if (response.id) {
            this.codeDemande = response.code_demande
            this.idDemande = response.id
            this.step = 2
            this.goto('step2')
          }
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
        })
    },

    async submitStep2() {
      this.isLoading = true

      // step2
      const formdata = new FormData()
      formdata.append('adresse_geo', this.adresse)
      formdata.append('code_postal', this.codepostal)
      formdata.append('ville', this.town)
      formdata.append('telephone', this.phoneFormatted)
      formdata.append('profession', this.work)
      formdata.append('id_demande', this.idDemande)
      formdata.append('code', this.codeDemande)

      await this.$store
        .dispatch('newdemandSetp2', formdata)
        .then((response) => {
          this.isLoading = false
          if (response.id) {
            this.step = 3
            this.goto('step3')
          }
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
        })
    },

    async submitStep3() {
      this.isLoading = true
      const formdata = new FormData()
      formdata.append('lieu_obtention_visa', this.acreditationcounrty)
      formdata.append('motif_voyage', this.motifvoyage)
      formdata.append('numpasseport', this.passportnumber)
      formdata.append('dateexpirationpasseport', this.expiredate)
      formdata.append('photopasseport_file', this.copypassport)
      formdata.append('justificationlogement_file', this.justificatiflogement)
      formdata.append('pays_delivrance', this.delivercountry)
      formdata.append('date_delivrance_passeport', this.deliverdate)
      formdata.append('ticket_avion_file', this.flugticket)
      formdata.append('date_depart', this.startdate)
      formdata.append('date_retour', this.enddate)
      formdata.append('id_demande', this.idDemande)
      formdata.append('code', this.codeDemande)

      await this.$store
        .dispatch('newdemandSetp3', formdata)
        .then((response) => {
          this.isLoading = false
          if (response.id) {
            this.step = 4
            this.goto('step4')
          }
          if (response.message == 'demand in progress') {
            this.editSnackbar = true
            this.editSnackbarColor = 'red'
            this.snackbar_text =
              'Désolé vous avez une demande en cours , veuillez attendre la fin du proccesus de traitement'
          } else if (response.message == 'not eligible') {
            this.editSnackbar = true
            this.editSnackbarColor = 'red'
            this.snackbar_text =
              "Vous n'êtes pas éligible pour effectuer une demande"
          }
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
        })
      this.has_passport = false
    },
    async submitStep4() {
      this.isLoading = true
      // step4
      const formdata = new FormData()
      formdata.append('nom_contact_cam', this.contactname)
      formdata.append('adrese_contact_cam', this.contactadresse)
      formdata.append('ville_contact_cam', this.contacttown)
      formdata.append('email_contact_cam', this.contactemail)
      formdata.append('nom_famille_cam', this.famillyname)
      formdata.append('adrese_famille_cam', this.famillyadresse)
      formdata.append('ville_famille_cam', this.famillytown)
      formdata.append('email_famille_cam', this.famillyemail)
      formdata.append('nom_residence_cam', this.residencename)
      formdata.append('adrese_residence_cam', this.residenceadresse)
      formdata.append('ville_residence_cam', this.residencetown)
      formdata.append('email_residence_cam', this.residenceemail)
      formdata.append('id_demande', this.idDemande)
      formdata.append('code', this.codeDemande)

      if (this.contactphone) {
        formdata.append('telephone_contact_cam', this.contactPhoneFormatted)
      }
      if (this.famillyphone && this.switch1) {
        formdata.append('telephone_famille_cam', this.famillyPhoneFormatted)
      }

      if (this.residencephone) {
        formdata.append('telephone_residence_cam', this.residencePhoneFormatted)
      }

      await this.$store
        .dispatch('newdemandSetp4', formdata)
        .then((response) => {
          this.isLoading = false

          if (response.id) {
            // les images

            this.step = 5
            this.goto('step5')
          }
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
        })
    },
    save(date) {
      this.$refs.menu.save(date)
    },

    expi_save(newdate) {
      this.$refs.editExpi.save(newdate)
    },
    deliversave(newdate) {
      this.$refs.delivermenu.save(newdate)
    },
    startsave(date) {
      this.$refs.startmenu.save(date)
    },
    endsave(date) {
      this.$refs.endmenu.save(date)
    },
    getColor(statut, level) {
      if (statut.toLowerCase() == 'valider' && level.toLowerCase() == 'final')
        return 'green'
      else if (statut.toLowerCase() == 'pending') return 'orange'
      else if (statut.toLowerCase() == 'complement') return 'info'
      else {
        return 'red'
      }
    },
    async payer() {
      this.isLoading = true
      const data = new FormData()
      data.append('codedemande', this.codeDemande)
      data.append('emailclient', this.connecteduser.email)
      await this.$store
        .dispatch('payment', data)
        .then((response) => {
          this.returndata = response
          // this.new_demand=false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async payer_demande(code) {
      const data = new FormData()
      data.append('codedemande', code)
      data.append('emailclient', this.connecteduser.email)
      this.loadingItem = code
      await this.$store
        .dispatch('payment', data)
        .then((response) => {
          this.returndata = response
          this.loadingItem = null
        })
        .catch((error) => {
          this.loadingItem = null
          console.log(error)
        })
    },
    dismissAlert() {
      setTimeout(() => {
        this.show_alert = false
      }, 20000)
    },
    show_image(img) {
      if (img) {
        let result = img.includes('https') || img.includes('http')
        if (result) {
          this.current_image = [img]
        } else {
          try {
            let url = URL.createObjectURL(img)
          this.current_image = [url]
          } catch (error) {
           
          }
        }
        this.$viewerApi({
          images: this.current_image,
        })
      }
    },

    async getNationalityonPassport() {
      const data = new FormData()
      data.append('numpasseport', this.passportnumber)
      await this.$store
        .dispatch('getnationalityonpassport', data)
        .then((response) => {
          if (response.data != '') {
            // let result = null;
            // result = this.nationalities.filter(function (element) {
            //   return element.nationalite_fr_fr == response.data;
            // });

            // this.editSnackbar = true;
            // this.editSnackbarColor = "warning";
            // this.snackbar_text =
            //   "Numéro de passport existant déjà avec la nationalaité " +
            //   response.data;
            this.nationalityOrigin = response.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    showMission() {
      this.$viewerApi({
        images: this.mission_images,
      })
    },
    // showComplement() {
    //   this.$viewerApi({
    //     images: this.complement_images,
    //   })
    // },
  },
  mounted() {
    this.dismissAlert()
  },
}
</script>
<style scoped>
@import '../../public/assets/css/style.css';

.v-progress-circular {
  margin: 0.75rem;
}

#site-header {
  margin-top: 10px;
}

#contact-grid {
  width: 100%;
  min-height: 85vh;
}
.info-div {
  margin-bottom: 20px;
}
.alert {
  margin-top: 30px;
}
.container.grid-list-xl .layout .flex {
  padding: 0px;
}
#alert-title {
  color: rgb(37, 51, 114);
}
#visa_dialog {
  background-image: url('../../public/cameroun.jpg');
  background-size: cover;
  background-repeat: no-repeat;
}
.container {
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
}

.img-viewer:hover {
  cursor: pointer;
}

@media (max-width: 700px) {
  #alert-title {
    font-size: 20px;
  }
  .ask-title {
    font-size: 18px;
  }
}
</style>
